import React from "react";
import { motion, scale } from "framer-motion";
import ProductStory from "../components/ProductStory.js"
import ProductInfo from "../components/ProductInfo.js"
import pinkClouds from "../assets/images/pink-clouds-divider.png";


// Import environment images //
import heroBg from "../assets/images/hero-galaxy-bg.png"; 
import heroPlanet from "../assets/images/hero-planet.svg"
// Import product images //
import blueGreenProd from "../assets/images/blue-green-eg-prod.png"
import yellowProd from "../assets/images/yellow-eg-prod.png"
import blueProd from "../assets/images/blue-eg-prod.png"
import redProd from "../assets/images/red-eg-prod.png"
// Import character images //
import boxerGuy from "../assets/images/boxer-guy.png"
import barefootGuy from "../assets/images/barefoot-guy.png"
import dressGirl from "../assets/images/dress-girl.png"
import layingGirl from "../assets/images/laying-girl.png"
import suitGuy from "../assets/images/suit-guy.png"
import urbanGuy from "../assets/images/urban-guy.png"



function Hero() {
  
  
// Set up array for images //
  const animatedImages = [

    {src: heroPlanet, 
      animation: "very-slow-rise", 
      alt: "Planet view from outer space", 
      modifier: "hero-planet",
      },

     /* Product images */
    {src: blueGreenProd, 
      animation: "fade-in-down-then-float", 
      alt: "blue green product image", 
      modifier: "blue-green-prod-close",
      motion: {
        initial: { y: "-50vh", opacity: 0 }, 
        animate: { 
          y: ["-50vh", "-15vh", "100vh"],   // drop in fast → settle → drift down
          opacity: [0, 1, 1]                // fade in as it enters, then stay visible
        },
        transition: {
          duration: 60,
          times: [0, 0.007, 1],               // 10% = fast drop, 90% = slow descent
          ease: ["easeOut", "linear"],       // easeIn for drop, linear for slow drift
          repeat: Infinity,
          repeatType: "loop"
        }
      }
    },
    {src: blueGreenProd, 
      animation: "fade-in-down-then-float", 
      alt: "blue green product image", 
      modifier: "blue-green-prod-far",
      motion: {
        initial: { y:-20 },
        animate: { y: [-20, 1000, -20] }, // up & down loop
        transition: { duration: 400, repeat: Infinity }
    }},
    {src: yellowProd, 
      animation: "fade-in-down-then-float", 
      alt: "yellow green product image", 
      modifier: "yellow-prod-close",
      motion: {
        initial: { y: "-50vh", opacity: 0 }, 
        animate: { 
          y: ["-50vh", "-25vh", "120vh"],   // drop in fast → settle → drift down
          opacity: [0, 1, 1]                // fade in as it enters, then stay visible
        },
        transition: {
          duration: 60,
          times: [0, 0.008, 1],               // 10% = fast drop, 90% = slow descent
          ease: ["easeOut", "linear"],       // easeIn for drop, linear for slow drift
          repeat: Infinity,
          repeatType: "loop"
        }
      }
    },
    {src: yellowProd, 
      animation: "fade-in-down-then-float", 
      alt: "yellow green product image", 
      modifier: "yellow-prod-far",
      motion: {
        initial: { y: "-50vh", opacity: 0 }, 
        animate: { 
          y: ["-50vh", "-35vh", "120vh"],   // drop in fast → settle → drift down
          opacity: [0, 1, 1]                // fade in as it enters, then stay visible
        },
        transition: {
          duration: 60,
          times: [0, 0.007, 1],               // 10% = fast drop, 90% = slow descent
          ease: ["easeOut", "linear"],       // easeIn for drop, linear for slow drift
          repeat: Infinity,
          repeatType: "loop"
        }
      }
    },
    {src: blueProd, 
      animation: "fade-in-down-then-float", 
      alt: "blue green product image", 
      modifier: "blue-prod-close",
      motion: {
        initial: { y: "-50vh", opacity: 0 }, 
        animate: { 
          y: ["-50vh", "-35vh", "120vh"],   // drop in fast → settle → drift down
          opacity: [0, 1, 1]                // fade in as it enters, then stay visible
        },
        transition: {
          duration: 60,
          times: [0, 0.007, 1],               // 10% = fast drop, 90% = slow descent
          ease: ["easeOut", "linear"],       // easeIn for drop, linear for slow drift
          repeat: Infinity,
          repeatType: "loop"
        }
      }
    },
    {src: blueProd, 
      animation: "fade-in-down-then-float", 
      alt: "blue green product image", 
      modifier: "blue-prod-far",
      motion: {
        initial: { y: "-50vh", opacity: 0 }, 
        animate: { 
          y: ["-50vh", "-30vh", "120vh"],   // drop in fast → settle → drift down
          opacity: [0, 1, 1]                // fade in as it enters, then stay visible
        },
        transition: {
          duration: 60,
          times: [0, 0.005, 1],               // 10% = fast drop, 90% = slow descent
          ease: ["easeOut", "linear"],       // easeIn for drop, linear for slow drift
          repeat: Infinity,
          repeatType: "loop"
        }
      }
    },
    {src: redProd, 
      animation: "fade-in-down-then-float", 
      alt: "red green product image", 
      modifier: "red-prod-close",
      motion: {
        initial: { y: "-50vh", opacity: 0 }, 
        animate: { 
          y: ["-50vh", "-35vh", "120vh"],   // drop in fast → settle → drift down
          opacity: [0, 1, 1]                // fade in as it enters, then stay visible
        },
        transition: {
          duration: 60,
          times: [0, 0.009, 1],               // 10% = fast drop, 90% = slow descent
          ease: ["easeOut", "linear"],       // easeIn for drop, linear for slow drift
          repeat: Infinity,
          repeatType: "loop"
        }
      }
    },
    {src: redProd, 
      animation: "fade-in-down-then-float", 
      alt: "red green product image", 
      modifier: "red-prod-far",
      motion: {
        initial: { y: "-50vh", opacity: 0 }, 
        animate: { 
          y: ["-50vh", "-35vh", "120vh"],   // drop in fast → settle → drift down
          opacity: [0, 1, 1]                // fade in as it enters, then stay visible
        },
        transition: {
          duration: 60,
          times: [0, 0.01, 1],               // 10% = fast drop, 90% = slow descent
          ease: ["easeOut", "linear"],       // easeIn for drop, linear for slow drift
          repeat: Infinity,
          repeatType: "loop"
        }
      }
    },

     /* Character images */
    {src: boxerGuy,
      animation: "fade-in-up-then-float", 
      alt: "character 1",
      modifier: "boxer-guy",

    },
    {src: barefootGuy, 
      animation: "fade-in-up-then-float", 
      alt: "character 2", 
      modifier: "barefoot-guy",

    },
    {src: dressGirl, 
      animation: "fade-in-up-then-float", 
      alt: "character 3", 
      modifier: "dress-girl",
      motion: {
        initial: { y: "65vh", opacity: 0 }, 
        animate: { 
          y: ["65vh", "30vh", "-100vh"],   // enter → drift up → leave
          opacity: [0, 1, 1]               // fade in, then stay visible
        },
        transition: {
          duration: 60,
          times: [0, 0.0085, 1],              // 0% = start, 10% = in place & visible, 100% = off screen
          ease: ["easeOut", "linear"],     // easeOut for rise, linear for drift
          repeat: Infinity,
          repeatType: "loop"
        }
      }
    },
    {src: layingGirl, 
      animation: "fade-in-up-then-float", 
      alt: "character 4", 
      modifier: "laying-girl",
  
    },
    {src: suitGuy, 
      animation: "fade-in-up-then-float", 
      alt: "character 5", 
      modifier: "suit-guy",
      motion: {
        initial: { y: "65vh", opacity: 0 }, 
        animate: { 
          y: ["65vh", "40vh", "-100vh"],   // enter → drift up → leave
          opacity: [0, 1, 1]               // fade in, then stay visible
        },
        transition: {
          duration: 60,
          times: [0, 0.01, 1],              // 0% = start, 10% = in place & visible, 100% = off screen
          ease: ["easeOut", "linear"],     // easeOut for rise, linear for drift
          repeat: Infinity,
          repeatType: "loop"
        }
      }
    },
    {src: urbanGuy, 
      animation: "fade-in-up-then-float", 
      alt: "character 6", 
      modifier: "urban-guy",
      motion: {
        initial: { y: "65vh", opacity: 0 }, 
        animate: { 
          y: ["65vh", "40vh", "-100vh"],   // enter → drift up → leave
          opacity: [0, 1, 1]               // fade in, then stay visible
        },
        transition: {
          duration: 60,
          times: [0, 0.01, 1],              // 0% = start, 10% = in place & visible, 100% = off screen
          ease: ["easeOut", "linear"],     // easeOut for rise, linear for drift
          repeat: Infinity,
          repeatType: "loop"
        }
      }
    },
  ]
// Show hero page //
  return (
    <div className="master-wrapper">
      {/* Hero Section */}
      <div
        className="hero-container"
        style={{
          position: "relative",
          backgroundImage: `url(${heroBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        {animatedImages.map((item, index) => (
          <img
            key={index}
            src={item.src}
            alt={item.alt || `hero element ${index}`}
            className={`hero-image ${item.animation} ${item.modifier || ""}`}
            initial={item.initial}
            animate={item.animate}
            transition={item.transition}
          />
        ))}

        <h1 className="hero-text">TRANSCEND</h1>
        {/* Cloud divider between Hero and ProductStory */}
        <div
          className="cloud-divider top"
          style={{
            backgroundImage: `url(${pinkClouds})`,
            position: "absolute",
            bottom: -150,
            width: "100%"
          }}
        />
      </div>


      {/* Product Story */}
      <ProductStory />

      {/* Product Info */}
      <ProductInfo />
    </div>
  );
}

export default Hero;